/** Touch tablet viewport band where the user may override mobile vs desktop UI. */
export const LAYOUT_TABLET_MIN_PX = 600
export const LAYOUT_TABLET_MAX_PX = 1280

export const LAYOUT_PREFERENCE_STORAGE_KEY = 'adams_layout_preference'

/** @typedef {'desktop' | 'mobile'} LayoutPreference */

export function detectTouchDevice() {
  return typeof navigator !== 'undefined' && navigator.maxTouchPoints > 0
}

/**
 * True when the device is touch and the viewport is in the tablet band.
 * @param {number} width
 */
export function isTabletTouchZone(width) {
  return (
    detectTouchDevice() &&
    width >= LAYOUT_TABLET_MIN_PX &&
    width <= LAYOUT_TABLET_MAX_PX
  )
}

/**
 * @param {object} params
 * @param {number} params.width
 * @param {LayoutPreference} params.layoutPreference
 */
export function resolveIsMobile({ width, layoutPreference }) {
  if (isTabletTouchZone(width)) {
    return layoutPreference === 'mobile'
  }

  if (width < LAYOUT_TABLET_MIN_PX) {
    return true
  }

  return false
}

/**
 * @returns {LayoutPreference}
 */
export function readLayoutPreference() {
  try {
    const stored = localStorage.getItem(LAYOUT_PREFERENCE_STORAGE_KEY)
    if (stored === 'desktop' || stored === 'mobile') {
      return stored
    }
  } catch {
    /* ignore */
  }
  return 'desktop'
}

/**
 * @param {LayoutPreference} preference
 */
export function writeLayoutPreference(preference) {
  try {
    localStorage.setItem(LAYOUT_PREFERENCE_STORAGE_KEY, preference)
  } catch {
    /* ignore */
  }
}
